import { observable, computed } from "mobx";
import { PulseBetMarketAdditionalData, BasicPulseBetViewModel } from "../../ViewModel";
import { StakeViewModel} from "../../../../blocks/PulseBetMarkets/data";
import { WinningsDataModel } from "../../WinningsDataModel";
import { CalculatedPeriod } from "../CalculatedPeriod/CalculatedPeriod";

export class PulseBetMarketComponentData extends BasicPulseBetViewModel {

    @observable onStakeChangeFading: boolean;
    public externalPlaceBetHandler: () => void;

    stakeInputData: StakeViewModel;
    @observable winings: WinningsDataModel;

    constructor(stakeInputData: StakeViewModel, pulseBetMetadata: PulseBetMarketAdditionalData, gameProgressInMilli: number, placeBetHandler?:() => void) {
        super(stakeInputData.stakeValue, pulseBetMetadata, gameProgressInMilli);
        this.stakeInputData = stakeInputData;
        this.placeBetHandler = this.placeBetHandler.bind(this);
        this.externalPlaceBetHandler = placeBetHandler ? placeBetHandler : () => {};
        this.onStakeChangeFading = false;

        let count = 1;
        this.winings = {
            winnings: this.wrappedCalculatedPeriods.map(period => (
                {
                    winningValue: period.formatedWin,
                    winningStatus: period.periodProgressState ? period.periodProgressState.progressStatus : undefined,
                    periodNumber: count++
                })),
            branchID: this.pulseBetMetadata.branchID
        };
    }

    @computed get wrappedCalculatedPeriods(): CalculatedPeriod[] {
        return this.calculatedPeriodHelperDependency.wrappedCalculatedPeriodsStateless(this.stakeInputData.stakeValue, this.pulseBetMetadata);
    }

    @computed get periodFrames() {
        return this.wrappedCalculatedPeriods.map(p => p.relativeRangeFormatted);
    }

    placeBetHandler() {
        // if (this.externalPlaceBetHandler) {
        //     this.externalPlaceBetHandler(this.stake, this.pulseBetMetadata, this.gameProgressInMilli);
        // }
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./data/models/ViewModel/PulseBetMarketComponentData/PulseBetMarketComponentData.ts